/* ==========================================================
   NDE International USD Converter
   Dawn 14.0.0 Compatible
   Safe Overlay Architecture
   ========================================================== */

(function () {
  'use strict';

  /* ---------- Configuration ---------- */

  if (
    !window.ndeInternational ||
    !window.ndeInternational.enabled ||
    !window.ndeInternational.isInternational
  ) {
    return;
  }
  document.documentElement.classList.remove('nde-usd-ready');

  const exchangeRate = parseFloat(
    window.ndeInternational.exchangeRate || 285
  );

  if (!exchangeRate || exchangeRate <= 0) {
    return;
  }

  /* ---------- Helpers ---------- */

  function formatUSD(amount) {
  return 'USD ' + amount.toFixed(2);
}

  /* ---------- Price Conversion ---------- */

  function convertPrices() {
    
    const selectors = [
        
        /* Product Page */
        '.price-item--regular',
        '.price-item--sale',
        
        /* Cart */
        '.cart-item__price-wrapper .price',
        '.cart-item__totals .price',
        '.cart__footer .totals__total-value',
        '.drawer__footer .totals__total-value',
        
        /* Search */
        '.predictive-search .price-item',
        
        /* Homepage / Collections */
        '.card-information .price-item--regular',
        '.card-information .price-item--sale'
    
    ];

    const elements = document.querySelectorAll(
      selectors.join(',')
    );

    elements.forEach((el) => {

      /*
       Prevent re-processing
      */
     
       const originalText = (el.innerText || '').trim();

/* Skip already converted USD prices */
if (
  el.dataset.ndeUsdProcessed === 'true' ||
  originalText.includes('USD')
) {
  return;
}

/* Only convert PKR prices */
if (
  !originalText.includes('Rs') &&
  !originalText.includes('PKR')
) {
  return;
}

const cleaned = originalText
  .replace(/PKR/gi, '')
  .replace(/Rs\.?/gi, '')
  .replace(/[^\d.,]/g, '')
  .replace(/,/g, '');

const pkr = parseFloat(cleaned);

if (isNaN(pkr) || pkr <= 0) {
  return;
}

      const usd = pkr / exchangeRate;

      el.dataset.ndeOriginalPrice = originalText;

      el.textContent = formatUSD(usd);

      el.dataset.ndeUsdProcessed = 'true';

    });
  }

  /* ---------- Cart Notice ---------- */

  function addCartNotice() {

    const selectors = [
        '.cart__footer',
        '.drawer__footer'
    
    ];

    selectors.forEach((selector) => {

      const container = document.querySelector(selector);

      if (!container) {
        return;
      }

      if (
        container.querySelector('.nde-checkout-notice')
      ) {
        return;
      }

      const notice = document.createElement('div');

      notice.className = 'nde-checkout-notice';

      notice.textContent =
      'Final checkout amount will be charged in PKR.';

      const checkoutButton = container.querySelector(
        'button[name="checkout"], .cart__checkout-button'
    );
    
    if (checkoutButton) {
        checkoutButton.parentNode.insertBefore(
            notice,
            checkoutButton
        );
    } else {
        container.appendChild(notice);
    }
});
}

  /* ---------- Mutation Observer ---------- */

  function observeChanges() {

    const observer = new MutationObserver(() => {

      convertPrices();

      addCartNotice();

    });

    observer.observe(document.body, {

      childList: true,
      subtree: true

    });

  }

  /* ---------- Initialisation ---------- */

function initialise() {

  convertPrices();

  addCartNotice();

  if (!window.ndeUsdObserverStarted) {
    window.ndeUsdObserverStarted = true;
    observeChanges();
  }

}

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initialise
  );

} else {

  initialise();

}

})();